var map = {
	"./pages/faq.md": "7369",
	"./pages/imprint.md": "b683",
	"./pages/jobs.md": "dc44",
	"./pages/press.md": "17da",
	"./pages/privacy.md": "f0d8",
	"./pages/terms.md": "85fc",
	"./pages/usage.md": "888b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1859";